var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.063 2H.938a.909.909 0 01-.663-.293A1.035 1.035 0 010 1C0 .735.099.48.275.293A.909.909 0 01.937 0h28.125c.25 0 .488.105.663.293C29.901.48 30 .735 30 1c0 .265-.099.52-.275.707a.909.909 0 01-.663.293z"
  })));
}

export default SvgMinus;